import { render, staticRenderFns } from "./mNewsInfo.vue?vue&type=template&id=3709178a&scoped=true&"
import script from "./mNewsInfo.vue?vue&type=script&lang=js&"
export * from "./mNewsInfo.vue?vue&type=script&lang=js&"
import style0 from "./mNewsInfo.vue?vue&type=style&index=0&id=3709178a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709178a",
  null
  
)

export default component.exports